module.exports = __webpack_public_path__ + "static/media/Piercing-ear-surfacetragus.c75a8f94.png";